module.exports = __webpack_public_path__ + "img/xlis_logo.ac914ad2.jpg";